import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import images from "../../data/images";
import { AppWrap, MotionWrap } from "../../wrapper";
import "./About.scss";

const About = () => {
  const { theme } = useContext(ThemeContext);
  const isDarkMode = theme === "dark";

  const experience = "2.5";

  return (
    <div className="flex flex-col gap-base flex-center about-wrapper">
      <h2 className="color-primary-text heading-1">
        The <span className="color-primary">Engineer</span> Behind the Screen
      </h2>
      <div className="flex flex-col gap-m neutral-900 highlight about-container">
        <span>Hi, I'm Amman,</span>
        <span>
          A Software Engineer with{" "}
          <a
            href="#experience"
            className="color-primary-text highlight-accent text-underline"
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById("experience");
              if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
          >
            {experience} years of experience
          </a>{" "}
          in full-stack development. I enjoy building high-performance
          applications that make an impact.
        </span>
        <span>
          I graduated from{" "}
          <a
            href="https://www.nu.edu.pk/"
            target="_blank"
            rel="noopener noreferrer"
            className="color-primary-text highlight-accent text-underline"
          >
            FAST National University of Compter and Emerging Sciences (NUCES)
          </a>{" "}
          with a CGPA of{" "}
          <span className="color-primary-text highlight-accent">3.5</span> ,
          earning a place on the Dean's and Rector's List multiple times and
          securing{" "}
          <span className="color-primary-text highlight-accent">
            1st position
          </span>{" "}
          in one of my semesters.
        </span>
        <span>
          Currently, I'm working at{" "}
          <a
            href="https://matrix.com.pk/"
            target="_blank"
            rel="noopener noreferrer"
            className="color-primary-text highlight-accent text-underline"
          >
            Matrix Systems
          </a>{" "}
          on a large-scale management and portfolio optimization platform,{" "}
          <span className="color-primary-text highlight-accent">
            MARS (Managed Accounts Rebalancing System)
          </span>
          . I contribute to critical modules involving portfolio analysis, risk
          management, and optimization, while ensuring best practices,
          performance tuning, and clean code for enterprise-level financial
          institutions.
        </span>
        <span>
          Previously, I worked at{" "}
          <a
            href="https://www.techlogix.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="color-primary-text highlight-accent text-underline"
          >
            Techlogix
          </a>{" "}
          on a major digital banking application used by{" "}
          <span className="color-primary-text highlight-accent">
            millions of users
          </span>
          . I developed key modules, optimized performance, and collaborated
          closely with my team to deliver reliable, efficient features for
          large-scale production systems.
        </span>
        <span>
          Alongside my full-time role, I've been freelancing on{" "}
          <a
            href="https://www.fiverr.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="color-primary-text highlight-accent text-underline"
          >
            Fiverr
          </a>{" "}
          for over 2 years. As a{" "}
          <span className="color-primary-text highlight-accent">
            Level 2 Seller
          </span>
          , I've successfully delivered{" "}
          <span className="color-primary-text highlight-accent">50+</span>{" "}
          projects with consistently{" "}
          <span className="color-primary-text highlight-accent">high</span>{" "}
          ratings, helping clients worldwide with custom software solutions,
          academic projects, and full application development.
        </span>
        <span>
          Outside of work, I love exploring new technologies, building personal
          projects, and relaxing with some PlayStation gaming.
        </span>
        <span>Thanks for stopping by!</span>
        <span>Amman Soomro</span>
        <span>@ammansoomro</span>
        <div className="full-width flex flex-justify-end mr-xxl">
          <img
            src={isDarkMode ? images.sign_light : images.sign_dark}
            className="w-1-5"
            alt="Signature"
          />
        </div>
      </div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(About, "flex full-width flex-col"),
  "about",
  "bg-color-base-bg"
);
